import { useMutation, useQuery } from '@tanstack/react-query'
import {
  createNotification,
  createNotificationSave,
  getImages,
  getUrlImage,
  getCountries,
  getAsociado
} from '../services/Services'

export const useCreateNotification = () => {
  return useMutation({
    mutationFn: ({ data, url }: { data: any; url: any }) => createNotification(data, url)
  })
}

export const useCreateNotificationSave = () => {
  return useMutation({
    mutationFn: ({ data, companyId }: { data: any; companyId: any }) =>
      createNotificationSave(data, companyId)
  })
}

export const useImages = (companyId: string, areaId: string, areaDetailId?: string) => {
  return useQuery({
    queryKey: ['images', companyId, areaId, areaDetailId],
    queryFn: () => getImages(companyId, areaId, areaDetailId),
    enabled: !!companyId && !!areaId
  })
}

export const useImageUrl = (id: string) => {
  return useQuery({
    queryKey: ['imageUrl', id],
    queryFn: () => getUrlImage(id),
    enabled: !!id
  })
}

export const useCountries = (page: number) => {
  return useQuery({
    queryKey: ['countries'],
    queryFn: () => getCountries(page)
  })
}

export const useAsociado = (nroAsociado?: string, url?: string) => {
  return useQuery({
    queryKey: ['asociado', nroAsociado, url],
    queryFn: () => getAsociado(nroAsociado, url),
    enabled: !!nroAsociado && !!url
  })
}

// Nuevo hook para obtener múltiples URLs de imágenes
export const useImagesUrls = (imageIds: string[]) => {
  const queries = imageIds.map((id) => ({
    queryKey: ['imageUrl', id],
    queryFn: () => getUrlImage(id),
    enabled: !!id
  }))

  return useQuery({
    queryKey: ['imagesUrls', imageIds],
    queryFn: async () => {
      const urls = await Promise.all(imageIds.map((id) => getUrlImage(id)))
      return urls
    },
    enabled: imageIds.length > 0
  })
}

// Nuevo hook para obtener el logo de un área
export const useAreaLogo = (companyId: string, areaId: string) => {
  const { data: imagesData } = useImages(companyId, areaId)

  const logoImage = imagesData?.body?.find((item: any) => item.idDocumentCategory.name === 'Logos')

  const { data: logoUrl } = useImageUrl(logoImage?.id || '')

  return {
    logoUrl,
    isLoading: !logoUrl && !!logoImage?.id
  }
}
